module.exports = __webpack_public_path__ + "img/upcoming-events_mlb-all-star.805c2aab.jpg";